import { IconSparkles, IconPlus, IconArrowRight } from "@tabler/icons-react";
import { useCompatRouter as useRouter } from "@/lib/compat-router/context";
import { useAuth } from "@/contexts/AuthContext";
import { buildSignInUrl } from "@/utils/helpers/authReturn";

const CREATE_LISTING_PATH =
  "/user/dashboard/properties/my-listings?createListing=1";

const PropertyCtaBanner = () => {
  const router = useRouter();
  const { is_logged_in } = useAuth();

  const handleListProperty = () => {
    if (is_logged_in) {
      router.push(CREATE_LISTING_PATH);
    } else {
      router.push(buildSignInUrl(CREATE_LISTING_PATH));
    }
  };

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
      <div className="relative overflow-hidden rounded-2xl border border-[#2D96A7]/20 bg-gradient-to-br from-[#2D96A7]/5 via-white to-white">
        <div
          className="absolute inset-0 opacity-[0.02]"
          style={{
            backgroundImage: `radial-gradient(circle at 2px 2px, #2D96A7 1px, transparent 0)`,
            backgroundSize: "24px 24px",
          }}
        />
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-[#2D96A7]/5 rounded-full blur-[100px]" />
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-[#2D96A7]/5 rounded-full blur-[80px]" />

        <div className="relative px-6 md:px-12 py-12 md:py-16 flex flex-col md:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 tracking-tight mb-2">
              Have a Property to Sell or Rent?
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl leading-relaxed">
              List your property on{" "}
              <span className="text-[#2D96A7] font-semibold">
                findnigeriaproperties.com
              </span>{" "}
              and reach thousands of verified buyers and tenants across Nigeria.
              It&apos;s fast, easy, and completely free to get started.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
            <button
              type="button"
              onClick={handleListProperty}
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#2D96A7] hover:bg-[#2D96A7]/90 text-white text-sm font-semibold rounded-xl transition-all duration-300 shadow-sm hover:shadow-md cursor-pointer"
            >
              <IconPlus className="w-4 h-4" />
              List Your Property
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PropertyCtaBanner;
